import { render, staticRenderFns } from "./JobInvoiceItemMonthReportTable.vue?vue&type=template&id=188f1976&scoped=true&"
import script from "./JobInvoiceItemMonthReportTable.vue?vue&type=script&lang=ts&"
export * from "./JobInvoiceItemMonthReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./JobInvoiceItemMonthReportTable.vue?vue&type=style&index=0&id=188f1976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f1976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VSnackbar,VTextField})
